import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { AppContext } from '../../AppContext';

const ExtraUspMobile = ({ signupFor }) => {
  const { siteAbbr } = useContext(AppContext);

  const croReplacements = ['YC', 'YC_DE'].find(elem => elem === siteAbbr);
  const showExtraUspMobile = signupFor;

  return (
    <>
      {showExtraUspMobile && croReplacements && (
        <div className='hidden-md hidden-lg mb-4x'>
          <p>
            <Trans i18nKey='fieldset_extra_usp_mobile.text'>
              contentPlaceholder
              <strong>candidate_amount</strong>
            </Trans>
          </p>
        </div>
      )}
    </>
  );
};

ExtraUspMobile.propTypes = {
  signupFor: PropTypes.string.isRequired
};

export default ExtraUspMobile;
